// @flow
import { postCreator } from '../../../../http';
import environment from '../../../../environment';

export const endpoints = Object.freeze({
  POST_CONFIRM_ARRIVAL: `${environment.apiUrl}/sale/:orderId/progress/arrive`,
});

export const postConfirmArrivalApi = postCreator(fetch, endpoints.POST_CONFIRM_ARRIVAL);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/received/api.js